enum UserRoleType {
  VenueEditor = 2,
  CommerceEditor = 3,
  FranchiseEditor = 5,
}

export default UserRoleType;
